import React from "react";

const Image = () => (
  <svg width="308" height="390" viewBox="0 0 308 390">
    <g fill="none" fillRule="evenodd">
      <path fill="#23C991" d="M11.58 378.7H33.7v-79.3H11.58z" />
      <path
        d="M11.58 307.2H25.4M15.73 358.88h13.83M15.73 366.49h13.83"
        stroke="#86E0C2"
        strokeWidth="2"
      />
      <path fill="#FE9840" d="M58.14 378.7h29.05v-73.63H58.14z" />
      <path
        d="M63.67 337.87h17.98M63.67 312.39h17.98M63.67 345.49h17.98"
        stroke="#FEC391"
        strokeWidth="2"
      />
      <path
        fill="#FE9840"
        d="M264.76 379.13l-10.94-1.68 10.8-70.44 10.94 1.68z"
      />
      <path
        d="M262.73 339.36l4.94.76M266.69 313.53l4.94.76M261.8 345.45l4.94.76M260.86 351.54l4.94.76"
        stroke="#FEC391"
        strokeWidth="2"
      />
      <path fill="#00A7DB" d="M37.96 378.7h16.6v-84.96h-16.6z" />
      <path d="M44.88 302.6h9.68" stroke="#75CFEC" strokeWidth="2" />
      <path fill="#75CFEC" d="M42.8 352.98h6.92v-33.51h-6.91z" />
      <path fill="#23C991" d="M278.03 378.7h17.98v-73.63h-17.98z" />
      <path fill="#86E0C2" d="M283.14 353.04h8.55v-36.7h-8.55z" />
      <path fill="#FE9840" d="M162.85 269.6l-.04-17.18 98.31-.21.04 17.18z" />
      <path
        d="M217.33 255.58l.02 10.63M251.36 255.5l.02 10.64M207.17 255.6l.02 10.64"
        stroke="#FEC391"
        strokeWidth="2"
      />
      <path fill="#00A7DB" d="M150.3 252.36h102.67V238.6H150.3z" />
      <path d="M242.27 244.34v8.02" stroke="#75CFEC" strokeWidth="2" />
      <path
        fill="#75CFEC"
        d="M181.39 248.35h40.5v-5.73h-40.5zM299.25 378.94h8.3v-98.37h-8.3zM.36 378.94h8.31v-98.37H.37z"
      />
      <path
        fill="#3BBAE3"
        d="M0 389.28h307.7v-10.76H0zM0 280.35h307.7v-10.76H0z"
      />
      <path
        fill="#75CFEC"
        d="M299.25 269.59h8.3v-73.12h-8.3zM.36 269.59h8.31v-73.12H.37z"
      />
      <path fill="#3BBAE3" d="M0 196.1h307.7v-10.75H0z" />
      <path
        fill="#75CFEC"
        d="M299.25 185.35h8.3V86.98h-8.3zM.36 185.35h8.31V86.98H.37z"
      />
      <path fill="#3BBAE3" d="M0 86.76h307.7V76H0z" />
      <path fill="#00A7DB" d="M174.03 76l-8.1 10.76h123.23L281.06 76z" />
      <g>
        <path
          d="M293 55.65C293 74.54 280.45 77 248.63 77 188.9 77 191 75.1 191 56.2c0-18.88 25.8-34.2 57.62-34.2C280.45 22 293 36.75 293 55.65"
          fill="#F6F6F6"
        />
        <path
          d="M293 55.03C293 73.58 280.45 76 248.63 76 188.9 76 191 74.13 191 55.59 191 37.04 216.8 22 248.63 22 280.45 22 293 36.49 293 55.03z"
          stroke="#DADADA"
          strokeWidth="3"
        />
        <path
          d="M264 76.58c-13.46 0-24.37-9.85-24.37-22 0-12.16 10.91-22 24.37-22s18.87 6.95 18.87 7.05"
          fill="#F6F6F6"
        />
        <path
          d="M264 76.58c-13.46 0-24.37-9.85-24.37-22 0-12.16 10.91-22 24.37-22s18.87 6.95 18.87 7.05"
          stroke="#DADADA"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M238.75 117a4.77 4.77 0 0 1-3.85-1.95c-10.08-13.73-11.83-31.35-4.07-41 5.04-6.26 12.91-7.7 21.6-3.95 11.43 4.94 20.27 5.64 26.33 2.18 13.53-7.71 11.2-18.57 13.82-18.27 2.61.27 2.66 19.67-8.93 26.43-8.83 5.15-20.6 4.6-35.02-1.63-4.63-2-8.11-1.6-10.35 1.18-5.4 6.73-2.13 20.66 4.32 29.46a4.74 4.74 0 0 1-3.85 7.55"
          fill="#DADADA"
        />
        <path
          d="M192 75.61c0 3.1-3.8 4.39-8.5 4.39s-8.5-1.29-8.5-4.39c0-3.1 3.8-5.61 8.5-5.61s8.5 2.51 8.5 5.61"
          fill="#F6F6F6"
        />
        <path
          d="M192 75.61c0 3.1-3.8 4.39-8.5 4.39s-8.5-1.29-8.5-4.39c0-3.1 3.8-5.61 8.5-5.61s8.5 2.51 8.5 5.61z"
          stroke="#DADADA"
          strokeWidth="3"
        />
        <path
          d="M211 75.61c0 3.1-3.8 4.39-8.5 4.39s-8.5-1.29-8.5-4.39c0-3.1 3.8-5.61 8.5-5.61s8.5 2.51 8.5 5.61"
          fill="#F6F6F6"
        />
        <path
          d="M211 75.61c0 3.1-3.8 4.39-8.5 4.39s-8.5-1.29-8.5-4.39c0-3.1 3.8-5.61 8.5-5.61s8.5 2.51 8.5 5.61z"
          stroke="#DADADA"
          strokeWidth="3"
        />
        <path
          d="M228.98 12.89a1.67 1.67 0 0 0-2.76-1.47L205.74 29.5a77.17 77.17 0 0 0-12.24-.9c-4.33 0-8.45.28-12.24.9l-20.48-18.08a1.67 1.67 0 0 0-2.76 1.47l3.73 28.77c-.8 2.01-1.25 4.3-1.25 6.9 0 7.62 7.95 14.53 14 19.5 5.96 4.91 9.95 7.94 19 7.94 8.06 0 11.24-2.4 16.97-6.4 7.23-5.03 16.03-12.6 16.03-21.05 0-2.6-.45-4.88-1.25-6.9l3.73-28.76z"
          fill="#F6F6F6"
        />
        <path
          d="M228.98 12.89a1.67 1.67 0 0 0-2.76-1.47L205.74 29.5a77.17 77.17 0 0 0-12.24-.9c-4.33 0-8.45.28-12.24.9l-20.48-18.08a1.67 1.67 0 0 0-2.76 1.47l3.73 28.77c-.8 2.01-1.25 4.3-1.25 6.9 0 7.62 7.95 14.53 14 19.5 5.96 4.91 9.95 7.94 19 7.94 8.06 0 11.24-2.4 16.97-6.4 7.23-5.03 16.03-12.6 16.03-21.05 0-2.6-.45-4.88-1.25-6.9l3.73-28.76z"
          stroke="#DADADA"
          strokeWidth="3"
        />
        <path
          d="M197 68.02c0 2.2-2.68 3.98-4 3.98-1.2 0-4-1.78-4-3.98s1.75-2.02 3.96-2.02c2.2 0 4.04-.18 4.04 2.02"
          fill="#FEAD64"
        />
        <path
          d="M186 70l-24 2M186 68l-26-5M200 70l24 2M200 68l26-5"
          stroke="#B3B3B3"
          strokeLinecap="round"
        />
        <path
          d="M175 57a6.06 6.06 0 0 1 9 0M202 57a6.06 6.06 0 0 1 9 0"
          stroke="#B3B3B3"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    </g>
  </svg>
);
export default Image;
